// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__3JOm6","tool":"styles_tool__14EAD","animate":"styles_animate__1qMhQ","rotate":"styles_rotate__3AWoa","rotateMobile":"styles_rotateMobile__22sUV"};